import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Form, Card } from 'react-bootstrap';
const isArray = require('lodash/isArray');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
// const ValidateUtil = require('../../util/ValidateUtil');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
const KeyboardUtil = require('../../util/keyboard');
import ProjectSelector from '../common/ProjectSelector';
import ErrorBox from '../common/ErrorBox';
import DistributionRestrictionWarningBox from '../common/DistributionRestrictionWarningBox';

const propTypes = {
    show: PropTypes.bool,
    submitHandler: PropTypes.func.isRequired,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    sourceChannelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    closeHandler: PropTypes.func.isRequired,
    defaultValue: PropTypes.string,
    action: PropTypes.object,
    childActionID: PropTypes.string,
    disableButton: PropTypes.bool,
    error: PropTypes.shape({
        message: PropTypes.string.isRequired,
        uiRefs: PropTypes.array,
    }),
};

const defaultProps = {
    show: true,
    defaultValue: "",
    action: null,
    childActionID: null,
    disableButton: false,
    error: null,
};

class CopyShortCourseModal extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            inputValue: this.props.defaultValue || "",
            selectedProject: this.props.projectId,
        };

        this.inputElem = React.createRef();
        this.onChangeInput = this.onChangeInput.bind(this);
        this.onDistributionWarningCheck = this.onDistributionWarningCheck.bind(this);
        this.onSelectProject = this.onSelectProject.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.submitIsDisabled = this.submitIsDisabled.bind(this);
        this.onKeyDownInput = this.onKeyDownInput.bind(this);
    }

    componentDidMount() {
        this.focusOnInput();
    }

    onChangeInput(e) {
        this.setState({ inputValue: e.target.value });
    }

    onDistributionWarningCheck(val) {
        this.setState({ warningAccepted: val });
    }

    onSelectProject(projectId, channelId) {
        this.setState({ selectedProject: projectId });
    }

    submitHandler(){
        this.props.submitHandler(this.state.inputValue, this.state.selectedProject);
    }

    focusOnInput() {
        const input = this.inputElem.current;
        if (!!input) {
            input.focus();
            
            if (!!this.props.defaultValue) {
                input.setSelectionRange(0, input.value.length);
            }
        }

    }

    submitIsDisabled() {
        return (
            this.props.disableButton
            || !this.state.selectedProject
            || !this.state.inputValue
            || (this.props.distributionRestricted && !this.state.warningAccepted)
        );
    }

    onKeyDownInput(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            e.preventDefault(); // prevent page from refreshing (Redmine #4190). unknown root cause
            if (!this.submitIsDisabled()) this.submitHandler();
        }
    }

    render() {
        return (
            <Modal
                className='select-project-modal'
                show={this.props.show}
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard={false}
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{Strings['en'].short_course.modals.COPY_COURSE_HD}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ErrorBox error={this.props.error} />
                    {this.props.distributionRestricted &&
                        <DistributionRestrictionWarningBox
                            className="font-size-md"
                            onChangeAcceptance={this.onDistributionWarningCheck}
                        />
                    }
                    <Form>
                        <Form.Group controlId="copy-act-modal-input">
                            <Form.Label>{Strings['en'].short_course.modals.COPY_COURSE_TITLE_LABEL}</Form.Label>
                            <Form.Control
                                ref={this.inputElem}
                                value={this.state.inputValue}
                                onChange={this.onChangeInput}
                                onKeyDown={this.onKeyDownInput}
                                isInvalid={
                                    !!this.props.error
                                    && isArray(this.props.error.uiRefs)
                                    && this.props.error.uiRefs.indexOf('input') >= 0
                                }
                            />
                        </Form.Group>
                        <Card body bg="light">
                            <ProjectSelector
                                label={Strings['en'].common.SEL_DEST_PROJ}
                                selectedProject={this.state.selectedProject}
                                onSelect={this.onSelectProject}
                                excludeProject={this.props.excludeProject}
                                permissionsFunc={PermissionsUtil.canCreateNewActivity}
                                contentType={Globals.content_type.COURSE}
                                restrictToChannelId={this.props.sourceChannelId}
                            />
                        </Card>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={this.submitIsDisabled()}
                        onClick={this.submitHandler}
                    >
                        {Strings['en'].common.COPY_LC}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

CopyShortCourseModal.propTypes = propTypes;
CopyShortCourseModal.defaultProps = defaultProps;

export default CopyShortCourseModal;